export const officialItems = [
  {
    id: 0,
    title: "RE T-shirt",
    image: "assets/images/Gear-tshirt.png",
    price: 30,
    brand: "Rebuild Electronics",
    condition: "New",
    model: "",
    year: 2022,
    comment:
      "Soon to be your favorite tee. Discover the extra soft difference 100% ring spun cotton makes in this finer, smooth-faced and durable must-have tee that features 1-inch extra length in the body.",
  },
  {
    id: 0,
    title: "RE Mug",
    image: "assets/images/gear_mug.png",
    price: 15,
    brand: "Rebuild Electronics",
    condition: "New",
    model: "",
    year: 2022,
    comment:
      "15 oz. Ceramic Mug​",
  },
];